export default function forwardTo(forwardUrl) {
  const url = new URL(window.location);
  window.history.pushState({}, '', url);

  window.location = forwardUrl;
}